import React, {MouseEvent, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';

import styles from './ButtonWithIcon.module.scss';
import Spinner from 'components/Spinner';

interface Props
  extends React.HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  component: 'a' | 'button';
  icon?: React.ReactNode;
  iconPosition: 'left' | 'right';
  iconSize: number;
  size: 'lg' | 'md' | 'sm';
  color:
    | 'danger'
    | 'green'
    | 'primary'
    | 'gray'
    | 'blue'
    | 'outlined'
    | 'ghost'
    | 'green-outlined';

  disabled?: boolean;
  loading?: boolean;
  children?: any;
  to?: string;
}

function ButtonWithIcon({
  component = 'button',
  className,
  children,
  icon,
  iconPosition = 'left',
  iconSize,
  size,
  color,
  loading,
  to,
  onClick,
  ...restProps
}: Props) {
  const [isLoading, setIsLoading] = useState(false);

  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    if (!onClick) return;

    setIsLoading(true);
    onClick(event);
    setIsLoading(false);
  }

  if (component === 'a' && to) {
    return (
      <Link
        to={to}
        className={cn(
          styles.root,
          //   styles[`--${icon}`],
          styles[`--${iconPosition}`],
          styles[`--${size}`],
          styles[`--${color}`],
          {[styles[`--loading`]]: loading},
          className
        )}
        {...restProps}
      >
        {iconPosition === 'left' && icon && (
          <div className={styles.icon}>{icon}</div>
        )}
        {children}
        {iconPosition === 'right' && icon && (
          <div className={styles.icon}>{icon}</div>
        )}
      </Link>
    );
  } else {
    return (
      <button
        className={cn(
          styles.root,
          //   styles[`--${icon}`],
          styles[`--${iconPosition}`],
          styles[`--${size}`],
          styles[`--${color}`],
          {[styles[`--loading`]]: loading || isLoading},
          className
        )}
        onClick={handleClick}
        {...restProps}
        disabled={restProps.disabled || isLoading}
      >
        {iconPosition === 'left' && icon}
        {children}
        {iconPosition === 'right' && icon}
        {(loading || isLoading) && (
          <div className={styles.loader}>
            <Spinner />
          </div>
        )}
      </button>
    );
  }
}

ButtonWithIcon.defaultProps = {
  component: 'button',
  iconPosition: 'left',
  iconSize: 16,
  size: 'sm',
  color: 'primary',
  type: 'button',
};

export default ButtonWithIcon;
